import { logger } from '../../../../utils/logger';
import {
  attachOutboundSessionDebugListeners,
  watchPeerConnectionDebug,
} from './peer-connection-debug.util';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AudioCode = any;

export function installAudioCodeCallInterceptor(audioCode: AudioCode): void {
  const originalCall = audioCode.call?.bind(audioCode);
  if (!originalCall) {
    return;
  }

  audioCode.call = function (mediaType: unknown, destination: unknown, extraHeaders: unknown) {
    logger.debug('[CXone DEBUG] audioCode.call() invoked:');
    logger.debug('[CXone DEBUG]   mediaType:', mediaType);
    logger.debug('[CXone DEBUG]   destination (webRTCDnis):', destination);
    logger.debug('[CXone DEBUG]   extraHeaders:', extraHeaders);

    const jssipUA = audioCode.jssipUA;
    if (jssipUA) {
      logger.debug('[CXone DEBUG]   jssipUA.isConnected():', jssipUA.isConnected?.());
      logger.debug('[CXone DEBUG]   jssipUA.isRegistered():', jssipUA.isRegistered?.());
    }

    try {
      const session = originalCall(mediaType, destination, extraHeaders);
      logger.debug('[CXone DEBUG] audioCode.call() returned:', session);

      if (session) {
        const jsSession = session.js_session;
        if (jsSession) {
          logger.debug('[CXone DEBUG] Got JsSIP RTCSession:');
          logger.debug('[CXone DEBUG]   id:', jsSession.id);
          logger.debug('[CXone DEBUG]   status:', jsSession.status);
          logger.debug('[CXone DEBUG]   direction:', jsSession.direction);

          watchPeerConnectionDebug(jsSession);
          attachOutboundSessionDebugListeners(jsSession);
        }
      }

      return session;
    } catch (error) {
      logger.error('[CXone DEBUG] audioCode.call() threw error:', error);
      throw error;
    }
  };
}
